import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { map } from 'rxjs/operators';
import { orgManagementsData } from 'src/app/STORE/selectors/orgmanagement.selector';
import { HttpBaseService } from 'src/app/base/http-base.service';
import * as OrgManagementAction from '../actions/orgmanagement.action';

@Injectable()
export class OrgManagementEffects {
  private actions$ = inject(Actions);
  private baseService = inject(HttpBaseService);
  private store = inject(Store);
  private messageService = inject(MessageService);
  private translate = inject(TranslateService);

  oldRecords = [];
  filteredList: any[];

  removeDuplicates(updateRecords) {
    const ids = updateRecords.map((o) => o.sid);
    this.filteredList = updateRecords.filter(({ sid }, index) => !ids.includes(sid, index + 1));
    return this.filteredList;
  }

  //   Get OrgManagement Data
  getOrgManagementItems$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(OrgManagementAction.getOrgManagement),
        map((action: any) => {
          return this.baseService[action.apiConstants?.method](action.apiConstants, action.filter).subscribe(
            (organizationData: any) => {
              this.store.select(orgManagementsData).subscribe((data: any) => {
                // console.log(organizationData.results)
                // console.log(data.organizationData)
                const oldOrgData = data.organizationData;
                if (oldOrgData !== undefined && oldOrgData !== null) {
                  this.oldRecords = oldOrgData;
                }
              });
              const updateRecords = [...this.oldRecords, ...organizationData.results];
              // console.log(updateRecords)
              this.removeDuplicates(updateRecords);
              // const ids = updateRecords.map(o => o.sid)
              // const filtered = updateRecords.filter(({sid}, index) => !ids.includes(sid, index + 1))
              // console.log(filtered)
              this.store.dispatch(
                OrgManagementAction.setOrgManagement({
                  organizationData: this.filteredList,
                  totalRecords: organizationData.total
                })
              );
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  getOrgManagementItemsWithSorting$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(OrgManagementAction.getOrgManagementWithSorting),
        map((action: any) => {
          return this.baseService[action.apiConstants?.method](action.apiConstants, action.filter).subscribe(
            (organizationData: any) => {
              this.store.select(orgManagementsData).subscribe((data: any) => {
                // console.log(organizationData.results)
                // console.log(data.organizationData)
                const oldOrgData = data.organizationData;
                if (oldOrgData !== undefined && oldOrgData !== null) {
                  this.oldRecords = oldOrgData;
                }
              });
              const updateRecords = [...this.oldRecords, ...organizationData.results];
              // console.log(updateRecords)
              this.removeDuplicates(updateRecords);
              // const ids = updateRecords.map(o => o.sid)
              // const filtered = updateRecords.filter(({sid}, index) => !ids.includes(sid, index + 1))
              // console.log(filtered)
              this.store.dispatch(
                OrgManagementAction.setOrgManagementWithSorting({
                  organizationData: organizationData.results,
                  totalRecords: organizationData.total
                })
              );
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );
  storeGitToken$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(OrgManagementAction.storeGitToken),
        map((action: any) => {
          return this.baseService[action.apiConstants?.method](action.apiConstants, action.gitToken).subscribe(
            (resp: any) => {
              if (resp) {
                console.log(resp);

                this.store.dispatch(
                  OrgManagementAction.updateOrgManagement({
                    organizationData: null
                  })
                );
              }
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  getGitConnection$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(OrgManagementAction.testGitConnection),
        map((action: any) => {
          return this.baseService[action.apiConstants?.method](action.apiConstants, action.testGitToken).subscribe(
            (resp: any) => {
              if (resp) {
                if (resp.code === 'success') {
                  this.showMessage('success', resp.response);
                }
                if (resp.code === 'error') {
                  this.showMessage('error', resp.response);
                }
              }
              this.store.dispatch(OrgManagementAction.testGitConnectionComplete());
            },
            (error: any) => {
              this.showMessage('error', this.translate.instant('CONNECTION_TEST_FAILED'));
              this.store.dispatch(OrgManagementAction.testGitConnectionComplete());
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  getSidBasedOrManagement$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(OrgManagementAction.getSidBasedOrManagement),
        map((action: any) => {
          const apiConstants = { ...action.apiConstants };
          apiConstants.url = action.apiConstants.url + action.sid;

          return this.baseService[apiConstants?.method](apiConstants).subscribe((sidOrgManagementData: any) => {
            if (sidOrgManagementData) {
              this.store.dispatch(
                OrgManagementAction.setSidBasedOrManagement({
                  sidOrgManagementData: { ...sidOrgManagementData }
                })
              );
            } else {
              this.store.dispatch(
                OrgManagementAction.setSidBasedOrManagement({
                  sidOrgManagementData: { error: true }
                })
              );
            }
          });
        })
      ),
    {
      dispatch: false
    }
  );
  srcText: string | null = null;
  // Get Org Management Data Search
  getOrManagementBasedOnSearch$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(OrgManagementAction.getOrManagementBasedOnSearch),
        map((action: any) => {
          const searchQuery = {
            start: 0,
            length: 100,
            search: action.searchFields
          };
          return this.baseService[action.apiConstants?.method](
            action.apiConstants,
            JSON.stringify(searchQuery)
          ).subscribe((organizationData: any) => {
            this.srcText = '';
            this.store.dispatch(
              OrgManagementAction.setOrgManagement({
                organizationData: organizationData.results,
                totalRecords: organizationData.total
              })
            );
          });
        })
      ),
    {
      dispatch: false
    }
  );

  //   Save OrgManagement Data
  saveOrgManagementItems$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(OrgManagementAction.sentOrgManagement),
        map((action: any) => {
          return this.baseService[action.apiConstants?.method](
            action.apiConstants,
            action.saveorganizationData
          ).subscribe(
            (response: any) => {
              if (action.apiConstants.method === 'post') {
                this.showMessage('success', 'Organization Created Successfully !');
              } else if (action.apiConstants.method === 'put') {
                this.showMessage('success', 'Organization Updated Successfully !');
              }

              this.store.dispatch(
                OrgManagementAction.updateOrgManagement({
                  organizationData: response
                })
              );
            },
            (err) => {
              console.log('error');
              console.log(err);
              this.store.dispatch(
                OrgManagementAction.getErrorMessage({
                  errorMessage: err
                })
              );
              if (err.error.ERROR_CODE === 'ORGANIZATION_SHORT_NAME_ALREADY_EXISTS') {
                this.showMessage('error', this.translate.instant('ORGANIZATION_SHORT_NAME_ALREADY_EXISTS'));
              } else if (err.error.ERROR_CODE === 'ORGANIZATION_ALREADY_EXISTS') {
                this.showMessage('error', this.translate.instant('ORGANIZATION_ALREADY_EXISTS'));
              }
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  // Delete Organziation
  deleteOrgManagement$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(OrgManagementAction.deleteOrgManagement),
        map((action: any) => {
          console.log('entered into organization delete');
          const apiConstants = { ...action.apiConstants };
          apiConstants.url = action.apiConstants.url + action.organizationId;
          return this.baseService[action.apiConstants?.method](apiConstants).subscribe(
            (menuData: any) => {
              console.log('Organization got deleted');
              this.showMessage('success', 'Organization Deleted Successfully');
              this.store.dispatch(
                OrgManagementAction.deleteOrgManagementSuccess({
                  organizationId: action.organizationId,
                  selectedOrg: action.selectedOrg
                })
              );
            },
            (error) => {
              this.store.dispatch(
                OrgManagementAction.deleteOrgManagementFailure({ organizationId: action.organizationId })
              );
              this.showMessage(
                'error',
                `An error occurred while attempting to delete the organization ${action.orgName}. Please try again later. If the issue persists, kindly contact our support team for assistance`
              );
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );
  // get orgData for header
  getOrgDataForHeader$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(OrgManagementAction.getOrgDataForHeader),
        map((action: any) => {
          const apiConstants = { ...action.orgApi };
          apiConstants.url = action.orgApi.url + action.sid;

          return this.baseService[apiConstants?.method](apiConstants).subscribe((orgDataForHeader: any) => {
            if (orgDataForHeader) {
              this.store.dispatch(
                OrgManagementAction.setOrgDataForHeader({
                  orgDataForHeader: { ...orgDataForHeader }
                })
              );
            } else {
              this.store.dispatch(
                OrgManagementAction.setOrgDataForHeader({
                  orgDataForHeader: { error: true }
                })
              );
            }
          });
        })
      ),
    {
      dispatch: false
    }
  );
  // Get Org list for header
  getOrglistforHeader$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(OrgManagementAction.getOrglistforHeader),
        map((action: any) => {
          let searchQuery = action?.searchQuery;
          if (action.searchText) {
            searchQuery = {
              ...searchQuery,
              ...{
                search: {
                  _global: `*${action.searchText}*`
                }
              }
            };
          }
          return this.baseService[action.apiConst?.method](action.apiConst, JSON.stringify(searchQuery)).subscribe(
            (organizationData: any) => {
              this.store.dispatch(
                OrgManagementAction.setOrglistforHeader({
                  orglistForHeader: organizationData.results,
                  searchText: action.searchText ? action.searchText : ''
                })
              );
            }
          );
        })
      ),
    {
      dispatch: false
    }
  );

  activateOrganization$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(OrgManagementAction.activateOrganization),
        map((action: any) => {
          const apiConstants = { ...action.apiConstants };
          apiConstants.url = `${action.apiConstants.url}/${action.organizationId}`;
          return this.baseService[action.apiConstants?.method](apiConstants).subscribe((orgData: any) => {
            this.store.dispatch(
              OrgManagementAction.updateOrgManagement({
                organizationData: orgData
              })
            );
            this.showMessage('success', this.translate.instant('ORGANIZATION_ACTIVATED_SUCCESSFULLY'));
          });
        })
      ),
    { dispatch: false }
  );

  deactivateOrganization$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(OrgManagementAction.deactivateOrganization),
        map((action: any) => {
          const apiConstants = { ...action.apiConstants };
          apiConstants.url = `${action.apiConstants.url}/${action.organizationId}`;
          return this.baseService[action.apiConstants?.method](apiConstants).subscribe((orgData: any) => {
            this.store.dispatch(
              OrgManagementAction.updateOrgManagement({
                organizationData: orgData
              })
            );
            this.showMessage('success', this.translate.instant('ORGANIZATION_DEACTIVATED_SUCCESSFULLY'));
          });
        })
      ),
    { dispatch: false }
  );

  showMessage(status: string, message: string, detail?: string) {
    this.messageService.clear();
    this.messageService.add({
      life: 10000,
      severity: status,
      summary: message,
      detail: detail
    });
  }
}
